import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=5cf52c32"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports